  import React, { useState, useEffect } from "react";
  import { 
    FaMapMarkerAlt, 
    FaEnvelope, 
    FaPhone, 
    FaClock,
    FaPaperPlane,
    FaCheckCircle,
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaTelegram,
    FaWhatsapp
  } from "react-icons/fa";
  import { HiOutlineMail, HiOutlineUser, HiOutlinePhone, HiOutlineDocumentText } from "react-icons/hi";

  const ContactUs = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [form, setForm] = useState({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });

    useEffect(() => {
      setIsVisible(true);
    }, []);

    const handleChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      console.log(form);
      setIsSubmitted(true);
      setTimeout(() => setIsSubmitted(false), 3000);
      // Reset form
      setForm({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      });
    };

    const contactInfo = [
      {
        icon: FaMapMarkerAlt,
        title: "Visit Us",
        details: ["Strada Mitropolit Gavrill", "Banulescu-Bodoni 429", "Chisinau, Moldova"],
        color: "from-blue-500 to-cyan-500",
        bg: "bg-blue-50"
      },
      {
        icon: FaEnvelope,
        title: "Email Us",
        details: ["dark@darkdrag.com"],
        color: "from-purple-500 to-pink-500",
        bg: "bg-purple-50"
      },
      {
        icon: FaClock,
        title: "Working Hours",
        details: ["Monday - Friday: 9AM - 6PM", "Saturday: 10AM - 4PM", "Sunday: Closed"],
        color: "from-amber-500 to-orange-500",
        bg: "bg-amber-50"
      },
    ];

    const socialLinks = [
      { icon: FaFacebookF, link: "#", color: "hover:bg-blue-600", label: "Facebook" },
      { icon: FaTwitter, link: "#", color: "hover:bg-sky-500", label: "Twitter" },
      { icon: FaInstagram, link: "#", color: "hover:bg-pink-600", label: "Instagram" },
      { icon: FaLinkedinIn, link: "#", color: "hover:bg-blue-700", label: "LinkedIn" },
      { icon: FaTelegram, link: "#", color: "hover:bg-sky-600", label: "Telegram" },
      { icon: FaWhatsapp, link: "#", color: "hover:bg-green-600", label: "WhatsApp" },
    ];

    const faqs = [
      { q: "How quickly do you respond?", a: "Within 24 hours on business days" },
      { q: "Do you offer international support?", a: "Yes, we serve customers worldwide" },
      { q: "Is my information secure?", a: "All communications are encrypted and secure" },
    ];

    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white overflow-hidden">
        
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20 md:py-28 overflow-hidden">
          {/* Animated Background */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-red-600/20 to-amber-600/20 rounded-full blur-3xl animate-pulse-slow"></div>
            <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-600/20 to-purple-600/20 rounded-full blur-3xl animate-pulse-slow animation-delay-2000"></div>
            
            {/* Grid Pattern */}
            <div className="absolute inset-0 bg-[url('data:image/svg+xml,...')] opacity-20"></div>
          </div>

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
            <div className={`transform transition-all duration-1000 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}>
              {/* Breadcrumb */}
              <div className="flex justify-center items-center gap-2 text-sm text-gray-400 mb-6">
                <span>Home</span>
                <span>•</span>
                <span className="text-red-500">Contact Us</span>
              </div>

              <h1 className="text-4xl md:text-6xl font-bold mb-6">
                <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                  Get In 
                </span>
                <span className="bg-gradient-to-r from-red-500 to-amber-500 bg-clip-text text-transparent">
                  {" "}Touch
                </span>
              </h1>
              
              <p className="text-gray-300 max-w-2xl mx-auto text-lg">
                We're here to help and answer any questions you might have
              </p>
            </div>
          </div>
        </section>

        {/* Contact Info Cards */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16 relative z-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((info, index) => {
              const Icon = info.icon;
              return (
                <div
                  key={index}
                  className={`bg-white rounded-2xl shadow-xl p-6 transform transition-all duration-700 hover:-translate-y-2 hover:shadow-2xl ${
                    isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 150}ms` }}
                >
                  <div className={`w-14 h-14 bg-gradient-to-br ${info.color} rounded-xl flex items-center justify-center mb-4 shadow-lg`}>
                    <Icon className="text-white text-2xl" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{info.title}</h3>
                  <div className="space-y-1">
                    {info.details.map((detail, i) => (
                      <p key={i} className="text-sm text-gray-600">{detail}</p>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* Main Contact Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16">
            
            {/* Left Column - Map and Info */}
            <div className={`space-y-8 transform transition-all duration-1000 ${
              isVisible ? 'translate-x-0 opacity-100' : '-translate-x-20 opacity-0'
            }`}>
              {/* Map */}
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                <div className="h-[300px] w-full bg-gradient-to-br from-gray-100 to-gray-200 relative">
                  {/* Placeholder for actual map - replace with Google Maps iframe or component */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center">
                      <FaMapMarkerAlt className="text-red-600 text-4xl mx-auto mb-2" />
                      <p className="text-gray-600">Interactive Map Location</p>
                      <p className="text-sm text-gray-500">Chisinau, Moldova</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Contact */}
              <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
                <h3 className="text-xl font-bold text-gray-900 mb-6">Quick Connect</h3>
                
                {/* Social Links */}
                <div className="mb-6">
                  <p className="text-sm text-gray-600 mb-3">Follow us on social media</p>
                  <div className="flex flex-wrap gap-3">
                    {socialLinks.map((social, index) => (
                      <a
                        key={index}
                        href={social.link}
                        className={`w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-600 hover:text-white ${social.color} transition-all duration-300 hover:scale-110`}
                        aria-label={social.label}
                      >
                        <social.icon className="text-sm" />
                      </a>
                    ))}
                  </div>
                </div>

                {/* FAQ Preview */}
                <div>
                  <p className="text-sm text-gray-600 mb-3">Frequently Asked</p>
                  <div className="space-y-3">
                    {faqs.map((faq, index) => (
                      <div key={index} className="border-b border-gray-100 pb-2">
                        <p className="text-sm font-semibold text-gray-900">{faq.q}</p>
                        <p className="text-xs text-gray-500">{faq.a}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Contact Form */}
            <div className={`transform transition-all duration-1000 delay-300 ${
              isVisible ? 'translate-x-0 opacity-100' : 'translate-x-20 opacity-0'
            }`}>
              <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
                {/* Form Header */}
                <div className="mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">Send us a Message</h3>
                  <p className="text-gray-600">We'll get back to you within 24 hours</p>
                </div>

                {/* Success Message */}
                {isSubmitted && (
                  <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center gap-3">
                    <FaCheckCircle className="text-green-500 text-xl" />
                    <p className="text-green-700 text-sm">Thank you! Your message has been sent successfully.</p>
                  </div>
                )}

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid sm:grid-cols-2 gap-5">
                    {/* Name Field */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Full Name *
                      </label>
                      <div className="relative">
                        <HiOutlineUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                          type="text"
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          required
                          className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 transition-all text-gray-900"
                          placeholder="Name"
                        />
                      </div>
                    </div>

                    {/* Email Field */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email Address *
                      </label>
                      <div className="relative">
                        <HiOutlineMail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                          type="email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          required
                          className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 transition-all text-gray-900"
                          placeholder="gmail@example.com"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid sm:grid-cols-2 gap-5">
                    {/* Phone Field */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Phone Number
                      </label>
                      <div className="relative">
                        <HiOutlinePhone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                          type="tel"
                          name="phone"
                          value={form.phone}
                          onChange={handleChange}
                          className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 transition-all text-gray-900"
                          placeholder="+91 834 567 890"
                        />
                      </div>
                    </div>

                    {/* Subject Field */}
                    <div className="relative">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Subject *
                      </label>
                      <div className="relative">
                        <HiOutlineDocumentText className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                          type="text"
                          name="subject"
                          value={form.subject}
                          onChange={handleChange}
                          required
                          className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 transition-all text-gray-900"
                          placeholder="How can we help?"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Message Field */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Your Message *
                    </label>
                    <textarea
                      name="message"
                      rows="5"
                      value={form.message}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 transition-all text-gray-900 resize-none"
                      placeholder="Tell us about your inquiry..."
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="w-full group relative px-8 py-4 bg-gradient-to-r from-red-600 to-amber-600 text-white font-semibold rounded-lg hover:shadow-xl hover:shadow-red-600/20 transition-all duration-300 overflow-hidden"
                  >
                    <span className="relative z-10 flex items-center justify-center gap-2">
                      Send Message
                      <FaPaperPlane className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </span>
                    <div className="absolute inset-0 bg-gradient-to-r from-red-700 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </button>

                  {/* Privacy Note */}
                  <p className="text-xs text-gray-500 text-center mt-4">
                    By submitting this form, you agree to our privacy policy and consent to being contacted.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 md:p-12 text-center relative overflow-hidden">
            {/* Background Decoration */}
            <div className="absolute inset-0 overflow-hidden">
              <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-red-600/20 to-amber-600/20 rounded-full blur-3xl"></div>
              <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-blue-600/20 to-purple-600/20 rounded-full blur-3xl"></div>
            </div>

            <div className="relative z-10">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                Prefer to talk directly?
              </h2>
              <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
                Our support team is available 24/7 to assist you with any questions
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
              
                <a
                  href="dark@darkdrag.com"
                  className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/20 transition-all duration-300 border border-white/20 inline-flex items-center gap-2"
                >
                  <FaEnvelope />
                  Email Support
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  export default ContactUs;